module.exports = "<div class=\"widgets\">\n\n  <div class=\"row\">\n    <div class=\"col-md-8\">\n      <ba-card cardTitle=\"Sector Type List\" baCardClass=\"with-scroll\">\n        <sector-type-list></sector-type-list>\n      </ba-card>\n    </div>\n\n    <div class=\"col-md-4\">\n      <ba-card cardTitle=\"New Sector Type\" baCardClass=\"with-scroll\">\n        <sector-type-form></sector-type-form>\n      </ba-card>\n    </div>\n\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/localization/components/sector-types/sector-types.component.html
// module id = 871
// module chunks = 8